export const BASE_URL = import.meta.env.VITE_API_BASE_URL as string;

export const INNER_FILE_DOWNLOAD_BASE_URL = import.meta.env.VITE_INNER_FILE_DOWNLOAD_BASE_URL as string;
